import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EXPENSES_REDIRECT_ROUTES } from './expenses-redirect.routes';

// Expenses moved to accounting-ui (ZEY-2808): every old /expenses URL forwards there. The module
// stays loaded for the purchase invoice's add-expense / link-expense drawers.
const routes: Routes = EXPENSES_REDIRECT_ROUTES;

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExpensesRoutingModule {}
